import * as React from "react";
import { SignUpPage as ConnectedSignUpPage } from "./signup-page";
import { Members as ConnectedMembers } from "./signup-page/members";

export const SignupPage = (props: any) => {
  return <ConnectedSignUpPage props={props} />;
};

export const Members = () => {
  return <ConnectedMembers />;
};
